import _ from 'lodash'
import qs from 'qs'
import { toast } from 'react-toastify'

import api from '../lib/api'

export const LIST_COMMENTS_SUCCESS = 'LIST_COMMENTS_SUCCESS'
export const LIST_COMMENTS_FAILURE = 'LIST_COMMENTS_FAILURE'
export const CREATE_COMMENT_FAILURE = 'CREATE_COMMENT_FAILURE'
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS'
export const SET_COMMENT_ERRORS_SUCCESS = 'SET_COMMENT_ERRORS_SUCCESS'
export const CLEAR_COMMENT_ERRORS_SUCCESS = 'CLEAR_COMMENT_ERRORS_SUCCESS'

export const createComment = (comment, images = []) => async dispatch => {
  try {
    const formData = new FormData()
    formData.append('comment', comment.comment)
    formData.append('source', comment.source)
    formData.append('defectId', comment.defectId)
    _.forEach(images, (image) => {
      formData.append('images', image)
    })
    await api.post(`/api/comments`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    await dispatch({ type: CREATE_COMMENT_SUCCESS })
  } catch (err) {
    toast.error('Failed to create a comment.')
    console.log(err.msg)
    dispatch({ type: CREATE_COMMENT_FAILURE, err })
  }
}

export const listComments = (query = {}) => async dispatch => {
  try {
    const { data } = await api.get(`/api/comments?${qs.stringify(query)}`)
    dispatch({ type: LIST_COMMENTS_SUCCESS, data: { query, list: data } })
  } catch (err) {
    toast.error('Failed to retrieve the list of the comments.')
    console.log(err.msg)
    dispatch({ type: LIST_COMMENTS_FAILURE, err })
  }
}

export const setCommentErrors = (errors) => dispatch => {
  dispatch({ type: SET_COMMENT_ERRORS_SUCCESS, data: { errors } })
}

export const clearCommentErrors = () => dispatch => {
  dispatch({ type: CLEAR_COMMENT_ERRORS_SUCCESS })
}



// WEBPACK FOOTER //
// ./src/actions/comment.js